class FarloUiTicketCalendar {

    constructor(element, _config) {
        this.container = element;
        this.options = _config || {};

        const startAttr = this.container.dataset.startMonth;
        const endAttr   = this.container.dataset.endMonth;

        this.minDate = new Date(startAttr || '1970-01-01');
        this.maxDate = new Date(endAttr   || '2100-12-31');

        // Start on minDate if provided, otherwise today
        this.currentDate = startAttr ? new Date(startAttr) : new Date();

        // Clamp currentDate into [min,max]
        if (this.monthIndex(this.currentDate) < this.monthIndex(this.minDate)) {
            this.currentDate = new Date(this.minDate);
        }
        if (this.monthIndex(this.currentDate) > this.monthIndex(this.maxDate)) {
            this.currentDate = new Date(this.maxDate);
        }

        this.render();
    }

monthIndex(d) {
  return d.getFullYear() * 12 + d.getMonth();
}


    padString(value,type) {
        if (type === "time") {
            if (value.length == 1 || value === 0) {
                return (value + "0").toString();
            }
        } else {
            if (value < 10) {
                return "0" + value;
            }
        }
        return value;
    }
    addParts(name) {
        if (name.match(/^Part /i)) {
            return " - " + name;
        }
        return "";
    }


    renderHeader() {
        const header = document.createElement('div');
        header.classList.add('farlo-ui-ticket-calendar__header');
    
        const prevButton = document.createElement('button');
        prevButton.classList.add('farlo-ui-ticket-calendar__button', 'farlo-ui-ticket-calendar__button--prev', 'button');
        prevButton.innerHTML = '&#10094;';
    
        if (parseInt(this.currentDate.getFullYear().toString() + this.padString(this.currentDate.getMonth()), 10) >
        parseInt(this.minDate.getFullYear().toString() + this.padString(this.minDate.getMonth()), 10)) {
            prevButton.classList.remove('farlo-ui-ticket-calendar__button-disabled');
            prevButton.addEventListener('click', () => this.prevMonth());
        } else {
            prevButton.classList.add('farlo-ui-ticket-calendar__button-disabled');
        }
    
        const title = document.createElement('h4');
        title.classList.add('farlo-ui-ticket-calendar__header-month-year');
        title.textContent = this.currentDate.toLocaleDateString(undefined, { year: 'numeric', month: 'long' });
    
        const nextButton = document.createElement('button');
        nextButton.classList.add('farlo-ui-ticket-calendar__button', 'farlo-ui-ticket-calendar__button--next', 'button');
        nextButton.innerHTML = '&#10095;';
    
        if (parseInt(this.currentDate.getFullYear().toString() + this.padString(this.currentDate.getMonth()), 10) <
            parseInt(this.maxDate.getFullYear().toString() + this.padString(this.maxDate.getMonth()), 10)) {
            nextButton.classList.remove('farlo-ui-ticket-calendar__button-disabled');
            nextButton.addEventListener('click', () => this.nextMonth());
        } else {
            nextButton.classList.add('farlo-ui-ticket-calendar__button-disabled');
        }
    
        header.appendChild(prevButton);
        header.appendChild(title);
        header.appendChild(nextButton);
    
        this.container.appendChild(header);
        this.renderAvailabilityKey();
    }
    
    renderAvailabilityKey() {
        const availabilityKey = document.createElement('div');
        availabilityKey.classList.add('farlo-ui-ticket-calendar__availability-key');
    
        const keys = [
            { label: 'Sold Out', class: 'sold-out' },
            { label: 'Last Few', class: 'last-few-tickets' },
            { label: 'Selling Fast', class: 'selling-fast' },
            { label: 'Available', class: 'available-tickets' },
        ];
    
        keys.forEach(key => {
            const keyItem = document.createElement('div');
            keyItem.classList.add('farlo-ui-ticket-calendar__key-item', key.class);
            keyItem.textContent = key.label;
            availabilityKey.appendChild(keyItem);
        });
    
        this.container.appendChild(availabilityKey);
    }
    

    renderDaysOfTheWeeks() {
        const div = document.createElement('div');
        div.classList.add('farlo-ui-ticket-calendar__weeks');
        const daysLetters = ['M<span>on</span>', 'T<span>ue</span>', 'W<span>ed</span>', 'T<span>hu</span>', 'F<span>ri</span>', 'S<span>at</span>', 'S<span>un</span>'];

        for (let i = 0; i < 7; i += 1) {
            const days = document.createElement('div');
            days.classList.add('farlo-ui-ticket-calendar__week-day');
            days.innerHTML = daysLetters[i];
            div.appendChild(days);
        }

        this.container.appendChild(div);
    }

    getUKDay(date) {
        let day = date.getDay();
        return day === 0 ? 6 : day - 1;
    }

    renderDaysInMonth() {
        const daysContainer = document.createElement('div');
        daysContainer.classList.add('farlo-ui-ticket-calendar__days');
    
        const year = this.currentDate.getFullYear();
        const month = this.currentDate.getMonth();
    
        const firstDay = this.getUKDay(new Date(year, month, 1));
        const daysInMonth = new Date(year, month + 1, 0).getDate();
    
        let elementCount = 0;

        for (let i = 0; i < firstDay; i++) {
            elementCount++;
            const blankDay = document.createElement('div');
            blankDay.classList.add('farlo-ui-ticket-calendar__day', 'farlo-ui-ticket-calendar__day--empty');
            daysContainer.appendChild(blankDay);
        }
    
        for (let day = 1; day <= daysInMonth; day++) {
            elementCount++;
            const dayElement = document.createElement('div');
            dayElement.classList.add('farlo-ui-ticket-calendar__day');
            
            const dayNumber = document.createElement('div');
            dayNumber.classList.add('farlo-ui-ticket-calendar__day-number');
            dayNumber.textContent = day;

            const eventDate = new Date(Date.UTC(year, month, day)).toISOString().split('T')[0];
            const eventsOnThisDay = nlivenPerformances.filter(event => event.start_date_time.startsWith(eventDate));

            dayElement.appendChild(dayNumber);

            let hasAvailability = false;
            if (eventsOnThisDay.length > 0) {
                eventsOnThisDay.forEach(event => {
                    const eventElement = document.createElement('div');
                    eventElement.classList.add('farlo-ui-ticket-calendar__event');

                    
                    const eventTime = new Date(event.start_date_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                    const eventInfo = document.createElement('div');
                    eventInfo.classList.add('farlo-ui-ticket-calendar__event-info');
    
                    const availability = parseInt(event.availability);
                    let availabilityClass = '';
                    if (availability === 0) {
                        availabilityClass = 'sold-out';
                    } else {
                        hasAvailability = true;
                        if (availability < _farloCalendarConfig.last_few) {
                            availabilityClass = 'last-few-tickets';
                        } else if (availability < _farloCalendarConfig.selling_fast) {
                            availabilityClass = 'selling-fast';
                        } else {
                            availabilityClass = 'available-tickets';
                        }
                    }

                    eventInfo.innerHTML = `<span href="javascript:void(0);" class="farlo-ui-ticket-calendar__event-link farlo-ui-ticket-calendar__event-link-${availabilityClass}"></span>`;
                    eventElement.classList.add(availabilityClass);
    
                    eventElement.appendChild(eventInfo);
                    dayElement.appendChild(eventElement);
                });
                if (hasAvailability) {
                    dayElement.addEventListener("click",() => {
                        this.populatePerformances(dayElement, eventDate)
                    })
                }
            } else {
                dayElement.classList.add("farlo-ui-ticket-calendar__day--empty");

            }
    
            daysContainer.appendChild(dayElement);
            if (elementCount % 7 === 0) {
                const calendarGap = document.createElement("div");
                calendarGap.classList.add("farlo-ui-ticket-calendar__gap");
                daysContainer.append(calendarGap);
            }
        }
        const calendarGap = document.createElement("div");
        calendarGap.classList.add("farlo-ui-ticket-calendar__gap");
        daysContainer.append(calendarGap);
        this.container.appendChild(daysContainer);
    }
    
    populatePerformances(_sel, eventDate) {
        this.container.querySelectorAll(".farlo-ui-ticket-calendar__day").forEach(_day => {
            _day.classList.remove("farlo-ui-ticket-calendar__day-active");
        });
        _sel.classList.add("farlo-ui-ticket-calendar__day-active");

        this.container.querySelectorAll(".farlo-ui-ticket-calendar__gap").forEach(_gap => {
            _gap.innerHTML = "";
            _gap.classList.remove("farlo-ui-ticket-calendar__gap-active");
        })
        const nextTarget = this.getNextElementByClass(_sel, 'farlo-ui-ticket-calendar__gap');
        nextTarget.classList.add("farlo-ui-ticket-calendar__gap-active");
        const eventsOnThisDay = nlivenPerformances.filter(event => event.start_date_time.startsWith(eventDate));
        eventsOnThisDay.forEach(_perf => {
            const performanceElement = document.createElement("a");
            performanceElement.href = _perf.booking_url;
            
            let availabilityClass = '';
            if (_perf.availability === 0) {
                availabilityClass = 'sold-out';
            } else {
                if (_perf.availability < _farloCalendarConfig.last_few) {
                    availabilityClass = 'last-few-tickets';
                } else if (_perf.availability < _farloCalendarConfig.selling_fast) {
                    availabilityClass = 'selling-fast';
                } else {
                    availabilityClass = 'available-tickets';
                }
            }
            performanceElement.classList.add("farlo-ui-ticket-calendar__perf", availabilityClass);

            const dtPerformance = new Date(_perf.start_date_time);

            const performanceDate = document.createElement("div");
            performanceDate.innerHTML = dtPerformance.getDate();
            performanceDate.classList.add("farlo-ui-ticket-calendar__perf-date");
            
            const performanceDay = document.createElement("div");
            performanceDay.innerHTML = _farloCalendarConfig.day_names[dtPerformance.getDay()];
            performanceDay.classList.add("farlo-ui-ticket-calendar__perf-day");

            const performanceTime = document.createElement("div");
            performanceTime.innerHTML = dtPerformance.getHours() + ":" + this.padString(dtPerformance.getMinutes(),"time") + this.addParts(_perf.name);
            performanceTime.classList.add("farlo-ui-ticket-calendar__perf-time");

            const performancePrice =  document.createElement("div");
            performancePrice.innerHTML = "From " + _farlo.helpers.strings.toCurrency(_perf.min_price)
            performancePrice.classList.add("farlo-ui-ticket-calendar__perf-price");

            const performanceButton = document.createElement("div");
            performanceButton.innerHTML = "Book Now";
            performanceButton.classList.add("farlo-ui-ticket-calendar__perf-button", "button", "button--outline", "wp-block-button__link", "is-style-small");

            const performanceLeft = document.createElement("div");
            performanceLeft.classList.add("farlo-ui-ticket-calendar__perf-left");
            performanceLeft.appendChild(performanceDate);
            performanceLeft.appendChild(performanceDay);

            const performanceRight = document.createElement("div");
            performanceRight.classList.add("farlo-ui-ticket-calendar__perf-right");
            performanceRight.appendChild(performanceTime);
            performanceRight.appendChild(performancePrice);


            const performanceControl = document.createElement("div");
            performanceControl.classList.add("farlo-ui-ticket-calendar__perf-control");
            performanceControl.append(performanceButton);
            
            performanceElement.appendChild(performanceLeft);
            performanceElement.appendChild(performanceRight);
            performanceElement.appendChild(performanceControl);

            nextTarget.appendChild(performanceElement);
        })
    }

    getNextElementByClass(startElement, targetClass) {
        let nextElement = startElement.nextElementSibling;
        
        while (nextElement) {
            if (nextElement.classList.contains(targetClass)) {
                return nextElement;
            }
            nextElement = nextElement.nextElementSibling;
        }
        
        return null;
    }

    async fetchEventsForMonth(y, m) {
        // Clear the container before adding new content
        this.container.innerHTML = '';
        this.renderHeader();
        this.renderDaysOfTheWeeks();
        this.renderDaysInMonth();
    }

    async render() {
        this.container.innerHTML = '';
        this.renderHeader();
        this.renderDaysOfTheWeeks();
        this.renderDaysInMonth();
    }

    prevMonth() {
        this.currentDate.setMonth(this.currentDate.getMonth() - 1);
        this.render();
    }

    nextMonth() {
        this.currentDate.setMonth(this.currentDate.getMonth() + 1);
        this.render();
    }

    handleEventClick(event) {
        if (this.options.eventClick) {
            this.options.eventClick(event);
        }
    }
}

export default FarloUiTicketCalendar;
